var _defs, _rect, _rect2, _rect3, _g, _rect4, _path, _g2, _rect5, _rect6, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _text;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoursesmenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_2117",
    "data-name": "Rettangolo 2117",
    width: 19.065,
    height: 15.745,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_2110",
    "data-name": "Rettangolo 2110",
    width: 13.91,
    height: 9.642,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4872",
    "data-name": "Raggruppa 4872",
    transform: "translate(-244 -379)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_2134",
    "data-name": "Rettangolo 2134",
    width: 24,
    height: 24,
    transform: "translate(244 379)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4869",
    "data-name": "Raggruppa 4869",
    transform: "translate(247 384)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4851",
    "data-name": "Raggruppa 4851",
    clipPath: "url(#clip-path)"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_2108",
    "data-name": "Rettangolo 2108",
    width: 15.779,
    height: 11.51,
    transform: "translate(0.428 0)",
    fill: "#fdc26e"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_2109",
    "data-name": "Rettangolo 2109",
    width: 13.91,
    height: 9.641,
    transform: "translate(1.363 0.934)",
    fill: "#2e8c8a"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4845",
    "data-name": "Raggruppa 4845",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4844",
    "data-name": "Raggruppa 4844",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4843",
    "data-name": "Raggruppa 4843",
    transform: "translate(1.363 0.934)",
    opacity: 0.08
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4842",
    "data-name": "Raggruppa 4842"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4841",
    "data-name": "Raggruppa 4841",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9081",
    "data-name": "Tracciato 9081",
    d: "M21.229,5.015,7.319,14.657V5.015Z",
    transform: "translate(-7.319 -5.015)",
    fill: "#fff"
  }))))))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_2112",
    "data-name": "Rettangolo 2112",
    width: 16.636,
    height: 0.48,
    transform: "translate(0 11.03)",
    fill: "#fedb83"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4850",
    "data-name": "Raggruppa 4850",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4849",
    "data-name": "Raggruppa 4849",
    clipPath: "url(#clip-path)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9082",
    "data-name": "Tracciato 9082",
    d: "M25.034,56.677a.243.243,0,0,1-.224.258h-1.4a.261.261,0,0,1,0-.516h1.4a.243.243,0,0,1,.224.258",
    transform: "translate(-18.867 -45.912)",
    fill: "#efefef"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4848",
    "data-name": "Raggruppa 4848",
    transform: "translate(1.363 0.934)",
    opacity: 0.52,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4847",
    "data-name": "Raggruppa 4847"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4846",
    "data-name": "Raggruppa 4846",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9083",
    "data-name": "Tracciato 9083",
    d: "M21.227,5.014v.467H7.811v9.174H7.318V5.014Z",
    transform: "translate(-7.318 -5.014)",
    fill: "#a5a5a4"
  }))))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_2114",
    "data-name": "Rettangolo 2114",
    width: 2.18,
    height: 0.905,
    transform: "translate(1.651 9.914)",
    fill: "#75c4d8"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_2115",
    "data-name": "Rettangolo 2115",
    width: 2.18,
    height: 0.204,
    transform: "translate(1.651 10.819)",
    fill: "#676670"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9084",
    "data-name": "Tracciato 9084",
    d: "M67.6,22.79l.1-.1-.1.1",
    transform: "translate(-55.013 -18.46)",
    fill: "#211f1c"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9085",
    "data-name": "Tracciato 9085",
    d: "M72.387,47.066a4.2,4.2,0,0,0-.156.48c-.008.024-.016.05-.024.076l-.063.22c-.054.182-.112.388-.176.608-.343,1.179-.8,2.762-1.052,3.31-.086,0-.171,0-.257-.011a33.8,33.8,0,0,1-.852-3.282c-.049-.211-.094-.416-.138-.606-.031-.142-.06-.275-.086-.4,0,0,0,0,0,0-.088-.4-.151-.693-.171-.782v0a.068.068,0,0,0,0-.008.347.347,0,0,1,.1-.291l0,0c.011-.015.023-.029.034-.046l0-.006a.031.031,0,0,0,.008-.012,1.529,1.529,0,0,0,.11-.169v0a1.261,1.261,0,0,0,.073-.156c.011-.029.021-.058.029-.088h0a1.538,1.538,0,0,0-.012-.832,2.6,2.6,0,0,0-.123-.356s.273-.088.637-.185c.161-.046.341-.091.524-.132.072-.016.145-.031.216-.045.594-.115,1.141-.151,1.083.137a3.421,3.421,0,0,0-.075.782,2.513,2.513,0,0,0,.1.658s0,0,0,0a1.813,1.813,0,0,0,.208.462.919.919,0,0,0,.129.167c-.106.12.021.38-.068.512",
    transform: "translate(-56.477 -36.018)",
    fill: "#e79f6c"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9086",
    "data-name": "Tracciato 9086",
    d: "M66.284,35.326a.064.064,0,0,1,0-.032c0,.029.006.053,0,.032",
    transform: "translate(-53.938 -28.721)",
    fill: "#973010"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9087",
    "data-name": "Tracciato 9087",
    d: "M68.874,53.412l.223-.367a3.005,3.005,0,0,0,.337.342c.369.318.456.313.605.53a1.134,1.134,0,0,1,.213.812,3.543,3.543,0,0,1-.443.527c-.129.086-1.239-.945-1.239-.945Z",
    transform: "translate(-55.801 -43.166)",
    fill: "#cee2ec"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9088",
    "data-name": "Tracciato 9088",
    d: "M79.529,53.427l-.22-.369a3.643,3.643,0,0,1-.4.381,1.923,1.923,0,0,0-.623.724.953.953,0,0,0,.3,1.1c.128.087,1.246-.935,1.246-.935Z",
    transform: "translate(-63.643 -43.177)",
    fill: "#cee2ec"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9089",
    "data-name": "Tracciato 9089",
    d: "M63.01,59.154a7.794,7.794,0,0,1-2.89,1.214,7.647,7.647,0,0,1-1.049.135c-.159.01-.32.015-.481.015-.068,0-.138,0-.207,0-.086,0-.171,0-.257-.011-.057,0-.115-.008-.172-.013a7.509,7.509,0,0,1-1.489-.265c-.255-.072-.506-.156-.75-.25a1.309,1.309,0,0,1-.034-.242,1.934,1.934,0,0,1-.011.223,7.627,7.627,0,0,1-.7-.324c-.089-.047-.177-.094-.265-.145a7.593,7.593,0,0,1-.7-.452c.135-.777.293-1.582.39-1.956a1.82,1.82,0,0,1,1.273-1.525c.05-.016.369-.142.688-.268l.288-.115c.146-.057.268-.107.33-.132l.018-.008.028-.01v0l.01.049a.22.22,0,0,0,.007.034.021.021,0,0,0,0,.01v0a1.506,1.506,0,0,0,.436.776,1.381,1.381,0,0,0,.176.14l.005.005.023.015a1.246,1.246,0,0,0,.611.211c.037,0,.075,0,.11,0a1.074,1.074,0,0,0,.127-.008,1.494,1.494,0,0,0,1.266-1.1s0-.008,0-.013c.01-.039.02-.081.028-.122l.007,0h0c.1.029.284.088.377.119s.182.06.265.091c.348.123.637.247.878.322a1.814,1.814,0,0,1,1.274,1.525c.085.32.233,1.159.385,2.075",
    transform: "translate(-43.945 -44.773)",
    fill: "#98bbca"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9090",
    "data-name": "Tracciato 9090",
    d: "M60.284,56.4c-.08.584-.132,2.153-.164,4.017a7.679,7.679,0,0,1-1.049.135c-.159.01-.32.015-.481.015-.068,0-.138,0-.206,0-.086,0-.171-.005-.257-.012-.057,0-.115-.008-.172-.013a7.511,7.511,0,0,1-1.489-.265c-.255-.072-.506-.156-.749-.25a1.31,1.31,0,0,1-.034-.242A1.932,1.932,0,0,1,55.67,60a7.627,7.627,0,0,1-.7-.323c-.089-.047-.177-.094-.265-.145a7.583,7.583,0,0,1-.7-.452c.135-.777.293-1.582.39-1.956A1.82,1.82,0,0,1,55.665,55.6c.05-.016.369-.142.688-.268l.288-.115c.146-.057.268-.107.33-.132l.018-.008.016.026.015.023.015.023v.008a1.12,1.12,0,0,0,.119.427,1.137,1.137,0,0,0,.5.491l0,0,.023.015a2.221,2.221,0,0,0,.611.211l.11.023c.044.008.089.016.138.023a6.323,6.323,0,0,0,1.068.073h.07c.187,0,.39-.01.61-.026",
    transform: "translate(-43.945 -44.822)",
    fill: "#abc7d5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9091",
    "data-name": "Tracciato 9091",
    d: "M82.326,63.439a.317.317,0,1,0,.317.317.317.317,0,0,0-.317-.317",
    transform: "translate(-66.736 -51.624)",
    fill: "#82afbe"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9092",
    "data-name": "Tracciato 9092",
    d: "M82.326,77.059a.317.317,0,1,0,.317.317.317.317,0,0,0-.317-.317",
    transform: "translate(-66.736 -62.708)",
    fill: "#82afbe"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9093",
    "data-name": "Tracciato 9093",
    d: "M70.147,63.439a.317.317,0,1,0,.317.317.317.317,0,0,0-.317-.317",
    transform: "translate(-56.825 -51.624)",
    fill: "#82afbe"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9094",
    "data-name": "Tracciato 9094",
    d: "M70.147,77.059a.317.317,0,1,0,.317.317.317.317,0,0,0-.317-.317",
    transform: "translate(-56.825 -62.708)",
    fill: "#82afbe"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9095",
    "data-name": "Tracciato 9095",
    d: "M88.585,34.3a.064.064,0,0,0,0-.033c0,.03-.006.055,0,.033",
    transform: "translate(-72.082 -27.888)",
    fill: "#973010"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9096",
    "data-name": "Tracciato 9096",
    d: "M78.154,29.556a1.623,1.623,0,0,0-.362-.675,1.9,1.9,0,0,0-.935-.583,3.3,3.3,0,0,1-.437-.12l-.025-.012v4.443h.016a.823.823,0,0,0,.328-.044,2.418,2.418,0,0,0,.73-.483l.065-.053a2.017,2.017,0,0,0,.572-.994,2.849,2.849,0,0,0,.049-1.478",
    transform: "translate(-62.166 -22.92)",
    fill: "#efa770"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9097",
    "data-name": "Tracciato 9097",
    d: "M68.309,25.405c-.055-.054-.12-.115-.193-.2a.578.578,0,0,0-.138-.124.452.452,0,0,0-.353-.019,1.012,1.012,0,0,0-.619.625,2.242,2.242,0,0,0-.093.773,3.6,3.6,0,0,1-.14.636,2.885,2.885,0,0,0,.069,1.39,2.017,2.017,0,0,0,.572.995l.105.087a2.246,2.246,0,0,0,.689.449.816.816,0,0,0,.313.044c.005,0,0-.67,0-.708v-3.48a.544.544,0,0,0-.212-.471",
    transform: "translate(-54.294 -20.375)",
    fill: "#fbb17a"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9098",
    "data-name": "Tracciato 9098",
    d: "M65.151,38.4a.42.42,0,0,1-.2-.091.458.458,0,0,1-.12-.274,1.28,1.28,0,0,0-.06-.3c-.026-.062-.067-.117-.091-.18a.2.2,0,0,1,.01-.193.221.221,0,0,1,.184-.068.27.27,0,0,1,.186.07q-.005.07-.006.142a3.515,3.515,0,0,0,.042.572c.015.109.035.216.057.321",
    transform: "translate(-52.616 -30.353)",
    fill: "#fbb17a"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9099",
    "data-name": "Tracciato 9099",
    d: "M86.13,37.561c-.024.063-.064.118-.091.18a1.272,1.272,0,0,0-.06.3.454.454,0,0,1-.12.274.371.371,0,0,1-.155.08,2.321,2.321,0,0,0,.071-.331,3.06,3.06,0,0,0,.025-.576c0-.05-.007-.1-.011-.147a.283.283,0,0,1,.147-.04.221.221,0,0,1,.184.068.2.2,0,0,1,.01.193",
    transform: "translate(-69.742 -30.353)",
    fill: "#fbb17a"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9100",
    "data-name": "Tracciato 9100",
    d: "M65.45,20.256a4.07,4.07,0,0,0-.5.159,2.552,2.552,0,0,0-.659.32,2.214,2.214,0,0,0-.818,1.506,3.889,3.889,0,0,0-.021.62,2.8,2.8,0,0,0,.152.906,2.289,2.289,0,0,0,.182.432,1.838,1.838,0,0,0,.133.189.074.074,0,0,1,.019-.01.508.508,0,0,1-.093-.245,1.294,1.294,0,0,0-.06-.3c-.026-.062-.067-.117-.091-.18a.2.2,0,0,1,.01-.193.222.222,0,0,1,.184-.068.254.254,0,0,1,.244.2.9.9,0,0,1,.013-.218,1.386,1.386,0,0,1,.023-.254,2.934,2.934,0,0,1,.347-.765,4.159,4.159,0,0,0,.384-.993,2.006,2.006,0,0,0,.945.671V20.211a1.931,1.931,0,0,0-.392.045",
    transform: "translate(-51.631 -16.447)",
    fill: "#323335"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9101",
    "data-name": "Tracciato 9101",
    d: "M78.771,22.636a5.348,5.348,0,0,0-.207-1.006,2.354,2.354,0,0,0-2.258-1.419v1.822a1.924,1.924,0,0,0,.243.065c.159.031.321.043.48.079a1.209,1.209,0,0,1,.839.611c0-.046-.055-.268,0-.185a2.335,2.335,0,0,1,.191.895.676.676,0,0,0,.073-.139c0,.026.006.051.009.077v0a.284.284,0,0,1,.147-.04.221.221,0,0,1,.184.068.2.2,0,0,1,.01.193c-.024.062-.064.118-.091.18a1.274,1.274,0,0,0-.06.3.456.456,0,0,1-.12.274c-.033.03-.124.048-.155.08-.054.055-.04.128-.048.212a2.131,2.131,0,0,0,.757-1.385,2.971,2.971,0,0,0,.006-.678",
    transform: "translate(-62.095 -16.446)",
    fill: "#2b2d33"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9102",
    "data-name": "Tracciato 9102",
    d: "M81.847,43.494a2.02,2.02,0,0,1,.1.373,1.6,1.6,0,0,1-.282,1.017,2.1,2.1,0,0,0-.39.834,9.523,9.523,0,0,0,.161,1.034,1.014,1.014,0,0,1-.691.954,2.28,2.28,0,0,0,.3-.458.77.77,0,0,0,.053-.534c-.04-.13-.126-.242-.173-.37a1.134,1.134,0,0,1-.055-.388,3.7,3.7,0,0,1,.248-1.624,4.6,4.6,0,0,0,.485-1.01c.013-.061.05-.125.066-.185a.165.165,0,0,1,.091-.122,1.228,1.228,0,0,0,.088.478",
    transform: "translate(-65.706 -35.005)",
    fill: "#2b2d33"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9103",
    "data-name": "Tracciato 9103",
    d: "M82.319,47.049a.981.981,0,0,1-.045.152c-.038.1-.156.308-.265.332a.781.781,0,0,0,.511-.4,1.035,1.035,0,0,0,.1-.649,1.56,1.56,0,0,1-.07-.708,1.516,1.516,0,0,1,.364-.472,1.459,1.459,0,0,0,.338-.935,1.923,1.923,0,0,0-.268-.967.815.815,0,0,1-.159-.407.256.256,0,0,0-.164.21.832.832,0,0,0,.02.279,2.132,2.132,0,0,1-.135,1.4c-.063.113-.141.217-.2.33a1.362,1.362,0,0,0-.162.811c.027.237.116.462.15.7a.942.942,0,0,1-.012.325",
    transform: "translate(-66.736 -34.988)",
    fill: "#323335"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9104",
    "data-name": "Tracciato 9104",
    d: "M69.87,35.733a.755.755,0,0,0-.114-.044h0l-.068-.02a2.316,2.316,0,0,0-1.5.11c-.085.012-.166.016-.211.018h0a.005.005,0,0,0,0,0,2.118,2.118,0,0,1-.211-.016,2.321,2.321,0,0,0-1.474-.117l-.049.013a1.013,1.013,0,0,0-.159.057c-.05.06,0,.15,0,.15s.041.013.046.016a.4.4,0,0,1,.073.039.118.118,0,0,1,.042.042.129.129,0,0,1,.013.042v.008c0,.029,0,.063,0,.089a1.42,1.42,0,0,0,.053.229.488.488,0,0,0,.2.262,1.44,1.44,0,0,0,.844.052c.234-.072.434-.5.455-.627.016-.08.112-.1.167-.1h.01c.055,0,.151.021.167.1.023.132.221.556.455.627a1.439,1.439,0,0,0,.844-.052.487.487,0,0,0,.195-.262,1.421,1.421,0,0,0,.054-.229.481.481,0,0,1,.02-.14s0,0,0-.005h0v0a.141.141,0,0,1,.046-.041l.028-.015h0l.033-.016c.005,0,.044-.013.046-.016s.05-.089,0-.15m-2.922.9a.755.755,0,0,1-.473-.169.477.477,0,0,1-.088-.172.649.649,0,0,1-.015-.387.215.215,0,0,1,.066-.1.786.786,0,0,1,.5-.111c.366.01.717.052.746.307a.657.657,0,0,1-.736.627m2.606-.341a.48.48,0,0,1-.088.172.756.756,0,0,1-.473.169.656.656,0,0,1-.735-.627c.028-.255.379-.3.745-.307a.783.783,0,0,1,.5.111.235.235,0,0,1,.068.1.65.65,0,0,1-.016.387",
    transform: "translate(-53.749 -28.965)",
    fill: "#292727"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9105",
    "data-name": "Tracciato 9105",
    d: "M64.088,19.211c-.009.152-.413.691-.392.88.023.21-.076.818-.028.978a10.2,10.2,0,0,1,1.6-.258,7.214,7.214,0,0,1,3.087.307,3.036,3.036,0,0,0-.411-1.907s-2.919-1.789-3.855,0",
    transform: "translate(-51.8 -14.986)",
    fill: "#cee2ec"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9106",
    "data-name": "Tracciato 9106",
    d: "M58.874,11.039c.007.224-.505,0-.579-.037a1.259,1.259,0,0,1-.513-.556c-.129-.268-.044-1.011.428-.978-.3-.8.332-1.518,1.292-1.639a1.129,1.129,0,0,0,.447-.107,1.77,1.77,0,0,1,.538-.252,1.018,1.018,0,0,1,1.133.385,1.382,1.382,0,0,1,1.35-.314,1.012,1.012,0,0,1,.8,1.039c.532-.135.766.476.851.812a1.251,1.251,0,0,1-.34,1.078,1.4,1.4,0,0,1-.859.421c-.243-.017-.5-.222-.782-.274a5.132,5.132,0,0,0-1.8-.011,16.044,16.044,0,0,0-1.576.5c-.313.09-.39.052-.393-.066",
    transform: "translate(-46.977 -6.049)",
    fill: "#dcf1fe"
  })))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "A",
    transform: "translate(6.182 7.008)",
    fill: "#fff",
    fontSize: 6,
    fontFamily: "SaveurSans-Regular, Saveur Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "A")))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoursesmenu);
export default __webpack_public_path__ + "static/media/coursesmenu.ff5b0c46ad28a68f290e28ae11845c32.svg";
export { ForwardRef as ReactComponent };